<script>
  import { Col, Label, Row, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { classnames } from '@client/utils/classnames';

  import { generateUUID } from '@common/utils/strings';

  export let borderless = false;

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };
  export let description = undefined;
  export let fill = false;
  export let htmlFor = undefined;
  export let label = '';
  export let tooltip = undefined;

  const id = `tooltip-${generateUUID()}`;

  $: classes = classnames(className, 'section-item', {
    borderless
  });

  $: cols = fill
    ? {
        xs: 12
      }
    : {
        xs: 12,
        md: 5,
        lg: 6
      };
</script>

<div class={classes}>
  <Row class="align-items-center" {...$$restProps}>
    <Col {...cols}>
      <div class="section-info-label">
        <Label for={htmlFor}>
          {label}
          <slot name="label" />
          {#if tooltip}
            <Icon name="help-circle" {id} />
            <Tooltip target={id} placement="top">
              {@html tooltip}
            </Tooltip>
          {/if}
        </Label>
      </div>
      {#if description}
        <p>{@html description}</p>
      {/if}
      <slot name="description" />
    </Col>
    <Col class="pt-1 pt-md-0">
      <slot />
    </Col>
  </Row>
</div>

<style lang="scss" src="./section-item.scss"></style>
